import React, { useState } from 'react';

function FAQ({ onBack }) {
  const [openIndex, setOpenIndex] = useState(null);

  const toggle = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  const faqs = [
    {
      category: '⌨️ 快捷键',
      items: [
        {
          q: '削词侠有哪些快捷键？',
          a: (
            <table style={{ width: '100%', borderCollapse: 'collapse', marginTop: '8px' }}>
              <thead>
                <tr style={{ background: '#f0f7ff' }}>
                  <th style={{ padding: '8px 12px', textAlign: 'left', border: '1px solid #e0e0e0' }}>快捷键</th>
                  <th style={{ padding: '8px 12px', textAlign: 'left', border: '1px solid #e0e0e0' }}>功能</th>
                </tr>
              </thead>
              <tbody>
                {[
                  ['Ctrl + X', '进入削词模式'],
                  ['Ctrl + C', '退出削词模式'],
                  ['Ctrl + L', '打开/关闭单词播放器'],
                  ['Ctrl + G', '切换绿屏直播模式'],
                  ['任意键', '完成一轮学习后继续下一轮'],
                ].map(([key, desc], i) => (
                  <tr key={i} style={{ background: i % 2 === 0 ? '#fff' : '#fafafa' }}>
                    <td style={{ padding: '8px 12px', border: '1px solid #e0e0e0' }}>
                      <code style={{ background: '#f0f0f0', padding: '2px 8px', borderRadius: '4px', fontFamily: 'monospace', fontSize: '0.95em' }}>
                        {key}
                      </code>
                    </td>
                    <td style={{ padding: '8px 12px', border: '1px solid #e0e0e0', color: '#555' }}>{desc}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          ),
        },
      ],
    },
    {
      category: '🚀 快速入门',
      items: [
        {
          q: '如何注册账号？',
          a: '点击右上角"注册"按钮，输入电子邮箱和密码（至少6位）即可完成注册。注册后可同步学习进度、使用削词功能，数据永久保存在云端。',
        },
        {
          q: '不登录可以使用吗？',
          a: '可以！不登录也可以正常学习单词，但学习进度不会保存，下次访问将重新开始。登录后才能使用削词功能并同步进度。',
        },
        {
          q: '忘记密码怎么办？',
          a: '点击右上角"登录"按钮，在弹窗中切换到"找回密码"标签，输入注册邮箱，系统会发送重置密码链接到您的邮箱。',
        },
      ],
    },
    {
      category: '⚔️ 削词功能',
      items: [
        {
          q: '什么是削词功能？',
          a: '削词是削词侠的核心功能。对于你已经熟练掌握的单词，可以将其"削掉"，从学习列表中永久移除，让你专注于还不熟悉的单词，提高学习效率。',
        },
        {
          q: '如何进入削词模式？',
          a: (
            <ol style={{ paddingLeft: '20px', lineHeight: '2' }}>
              <li>登录账号后，在学习页面遇到想要削掉的单词</li>
              <li>点击"进入削词模式"按钮，或按快捷键 <code style={{ background: '#f0f0f0', padding: '2px 6px', borderRadius: '4px' }}>Ctrl + X</code></li>
              <li>单词会被隐藏，在输入框中正确拼写该单词</li>
              <li>拼写正确后该单词自动削除，继续下一个</li>
              <li>输入错误会退出削词模式，需重新进入</li>
              <li>按 <code style={{ background: '#f0f0f0', padding: '2px 6px', borderRadius: '4px' }}>Ctrl + C</code> 或点击"退出削词模式"按钮可随时退出</li>
            </ol>
          ),
        },
        {
          q: '削掉的单词还能找回来吗？',
          a: '可以！进入"个人中心"，找到对应的级别，点击"重置"即可清除该级别的所有削词记录，重新从头开始学习。',
        },
      ],
    },
    {
      category: '📚 学习功能',
      items: [
        {
          q: '学习进度如何同步？',
          a: '登录账号后，每次正确输入单词都会实时同步到云端。切换设备或重新打开网页，进度会自动恢复到上次学习的位置。',
        },
        {
          q: '如何切换级别？',
          a: '在页面顶部"当前级别"下拉菜单中选择对应级别即可。支持小学、初中、高中、四级、六级、考研/托福、雅思/GRE共7个级别。',
        },
        {
          q: '如何切换英式/美式发音？',
          a: '在单词下方点击"美式"或"英式"按钮即可切换发音类型。点击🔊图标单次播放，点击🔁图标循环播放。',
        },
        {
          q: '什么是单词播放器？',
          a: '单词播放器（Ctrl+L）可以自动连续播放当前级别的单词发音，适合通勤、睡前等场景的听力学习。',
        },
        {
          q: '音效怎么开启？',
          a: '在学习页面勾选"开启音效"复选框即可。开启后，输入字母、正确完成单词、削词成功等操作都会有对应的剑鸣音效，让学习更有趣！',
        },
      ],
    },
    {
      category: '📱 小程序',
      items: [
        {
          q: '削词侠有微信小程序吗？',
          a: '有！微信搜索"削词侠"即可找到我们的小程序，随时随地学习英语词汇，与网页端数据互通，进度实时同步。',
        },
      ],
    },
    {
      category: '🟢 直播绿屏模式',
      items: [
        {
          q: '什么是绿屏模式？',
          a: '绿屏模式专为直播设计。按 Ctrl+G 或点击标题旁的🟢按钮进入绿屏模式，页面背景变为绿色。在直播软件（如OBS、抖音伴侣）中使用绿幕抠像功能，即可将学习页面叠加在摄像头画面上，边直播边学习英语单词。',
        },
        {
          q: '绿屏模式下二维码会自动显示吗？',
          a: '是的！进入绿屏模式后，页面右下角的小程序二维码会自动展开，方便直播观众扫码体验削词侠小程序。',
        },
      ],
    },
    {
      category: '❓ 其他',
      items: [
        {
          q: '网站数据安全吗？',
          a: '您的学习数据存储在安全的云端服务器，密码经过加密处理，我们不会将您的个人信息分享给第三方。详情请查看我们的隐私政策。',
        },
        {
          q: '发现问题或有建议怎么反馈？',
          a: (
            <span>
              欢迎发送邮件至
              <a href="mailto:vincentyip@126.com" style={{ color: '#1890ff', margin: '0 4px' }}>
                vincentyip@126.com
              </a>
              反馈问题或建议，我们会认真阅读每一封邮件并持续改进产品。
            </span>
          ),
        },
      ],
    },
  ];

  return (
    <div style={{ padding: '40px 20px', maxWidth: '800px', margin: '0 auto' }}>
      <button
        onClick={onBack}
        style={{
          marginBottom: '20px',
          padding: '10px 20px',
          background: '#1890ff',
          color: 'white',
          border: 'none',
          borderRadius: '4px',
          cursor: 'pointer',
          fontSize: '1em',
        }}
      >
        ← 返回主页
      </button>

      <h1 style={{ fontSize: '2.5em', marginBottom: '8px', color: '#333' }}>常见问题</h1>
      <p style={{ color: '#999', marginBottom: '32px', fontSize: '1em' }}>
        没找到答案？欢迎发邮件至
        <a href="mailto:vincentyip@126.com" style={{ color: '#1890ff', margin: '0 4px' }}>
          vincentyip@126.com
        </a>
        联系我们
      </p>

      {faqs.map((section, sIndex) => (
        <div key={sIndex} style={{ marginBottom: '32px' }}>
          <h2 style={{
            fontSize: '1.2em',
            color: '#1890ff',
            marginBottom: '12px',
            paddingBottom: '8px',
            borderBottom: '2px solid #e8f4ff',
          }}>
            {section.category}
          </h2>
          {section.items.map((item, iIndex) => {
            const index = `${sIndex}-${iIndex}`;
            const isOpen = openIndex === index;
            return (
              <div
                key={iIndex}
                style={{
                  marginBottom: '8px',
                  border: '1px solid #e8e8e8',
                  borderRadius: '8px',
                  overflow: 'hidden',
                  transition: 'box-shadow 0.2s',
                  boxShadow: isOpen ? '0 2px 8px rgba(24,144,255,0.1)' : 'none',
                }}
              >
                <button
                  onClick={() => toggle(index)}
                  style={{
                    width: '100%',
                    padding: '14px 16px',
                    background: isOpen ? '#f0f7ff' : '#fafafa',
                    border: 'none',
                    textAlign: 'left',
                    cursor: 'pointer',
                    fontSize: '1em',
                    fontWeight: '600',
                    color: isOpen ? '#1890ff' : '#333',
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    transition: 'all 0.2s',
                  }}
                >
                  <span>{item.q}</span>
                  <span style={{
                    fontSize: '1.2em',
                    transform: isOpen ? 'rotate(180deg)' : 'rotate(0)',
                    transition: 'transform 0.2s',
                    color: '#1890ff',
                  }}>
                    ▾
                  </span>
                </button>
                {isOpen && (
                  <div style={{
                    padding: '14px 16px',
                    background: 'white',
                    color: '#555',
                    lineHeight: '1.8',
                    fontSize: '0.95em',
                    borderTop: '1px solid #e8f4ff',
                  }}>
                    {item.a}
                  </div>
                )}
              </div>
            );
          })}
        </div>
      ))}
    </div>
  );
}

export default FAQ;